/*
 * @Description:  按钮权限数据中心
 * @Author: mdb
 * @Date: 2022-07-25 14:14:37
 * @LastEditTime: 2022-08-25 19:05:19
 * @LastEditors: mdb
 */
import { defineStore } from 'pinia'
import { buttonPermissions } from '@/api/common'

interface PermissionState {
  permission: string[]
}

export const usePermissionStore = defineStore({
  id: 'permission',
  state: (): PermissionState => ({
    permission: []
  }),
  actions: {
    setPermCodeList(codeList: string[]) {
      this.permission = codeList
    },
    async getPermissionBtn() {
      try {
        const { data } = await buttonPermissions()
        this.setPermCodeList(data)
      } catch (error) {
        throw new Error()
      }
    }
  }
})
